//src/ThemeContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';

// Créer le contexte
const ThemeContext = createContext();

// Créer le fournisseur (le composant qui va gérer l'état)
export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // 🎯 CORRECTION : Récupération synchrone depuis localStorage
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  });

  useEffect(() => {
    // 🎯 CORRECTION : Application FORCÉE du thème au body et html
    const body = document.body;
    const html = document.documentElement;
    
    // Nettoyer toutes les classes de thème existantes
    body.classList.remove('light-theme', 'dark-theme', 'light-mode', 'dark-mode');
    html.classList.remove('light-theme', 'dark-theme', 'light-mode', 'dark-mode');
    
    // Appliquer le thème actuel
    if (theme === 'dark') {
      body.classList.add('dark-theme', 'dark-mode');
      html.classList.add('dark-theme', 'dark-mode');
      body.style.backgroundColor = '#121212';
      body.style.color = '#ffffff';
      html.style.backgroundColor = '#121212';
      html.style.color = '#ffffff';
    } else {
      body.classList.add('light-theme', 'light-mode');
      html.classList.add('light-theme', 'light-mode');
      body.style.backgroundColor = '#ffffff';
      body.style.color = '#000000';
      html.style.backgroundColor = '#ffffff';
      html.style.color = '#000000';
    }
    
    // 🎯 CORRECTION : Sauvegarder la préférence
    localStorage.setItem('theme', theme);
    
    console.log(`Thème appliqué: ${theme}`); // Pour debug
  }, [theme]); // Exécuter ce code quand le thème change

  // 🎯 CORRECTION : Appliquer le thème immédiatement au chargement
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
  }, []);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // 🎯 CORRECTION : Valeur par défaut complète
  const value = {
    theme,
    toggleTheme,
    isDark: theme === 'dark',
    isLight: theme === 'light'
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};